module.exports = __webpack_public_path__ + "static/img/bg_b.fee7569f.png";